import React, { useState, useEffect } from "react";
import arrowIcon from "../assets/images/arrow-top.svg"; // Import your arrow image
import "../assets/styles/Navbar.css"; // Import your CSS file

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Detect scroll position
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button className={`scroll-to-top ${isVisible ? "visible" : "hidden"}`} onClick={scrollToTop}>
      <img src={arrowIcon} alt="Scroll to top" />
    </button>
  );
};

export default ScrollToTop;
